import ITermosAceiteOnboardingRequest from '../entities/ITermosAceiteOnboardingRequest'
import ITermosAceiteOnboardingResponse from '../entities/ITermosAceiteOnboardingResponse'
import { IPagamentoRepository } from '../repositories/IPagamentoRepository'

export interface ITermosOnboarding {
  execute(
    data: ITermosAceiteOnboardingRequest,
  ): Promise<ITermosAceiteOnboardingResponse>
}

export default class TermosOnboardingImpl implements ITermosOnboarding {
  constructor(private readonly pagamentosRepository: IPagamentoRepository) {}
  async execute(
    data: ITermosAceiteOnboardingRequest,
  ): Promise<ITermosAceiteOnboardingResponse> {
    return this.pagamentosRepository.termosAceiteOnboarding(data)
  }
}
